/*
  ============================================================
  carrinho.js — Carrinho da Levili (AJAX + gaveta lateral)
  ============================================================

  O QUE FAZ:
  1. Formulários de produto (action .../cart/add), em qualquer página:
     - Se o form tem o seletor de número ([data-size-picker] com radios) e
       nenhum número foi escolhido: mostra "Escolha o seu número" em
       [data-size-error], faz os chips tremerem e não envia.
     - Senão: adiciona via Cart AJAX API (/cart/add.js), re-renderiza a
       gaveta pela Section Rendering API (?sections=levili-carrinho),
       atualiza os contadores [data-cart-count] e abre a gaveta
       (ou vai para /cart se settings.cart_type = "page").
     - Erro do Shopify (ex.: sem estoque): aviso vermelho (toast).
     - Falha de rede: envia o formulário do jeito normal (sem AJAX).
  2. Gaveta #CarrinhoDrawer:
     - Abre por [data-cart-toggle] (ícone do cabeçalho) ou pelo evento
       document.dispatchEvent(new CustomEvent('carrinho:abrir')).
     - Fecha por [data-cart-close], scrim ou Esc; prende o foco dentro
       dela enquanto aberta; devolve o foco ao botão que abriu.
     - Quantidade +/- e remover (/cart/change.js) com re-render.
  3. Página do carrinho (/cart): os botões +/- enviam o formulário nativo
     ([data-cart-page-form]) para atualizar.

  SEM JS: tudo continua funcionando pelos formulários nativos do Shopify.

  EVENTOS EMITIDOS (document):
  - 'carrinho:atualizado'  detail: { itemCount }
  - 'carrinho:adicionado'  detail: { item }
*/
(function () {
  'use strict';

  var L = window.levili || {};
  var C = L.config || {};
  var R = C.routes || {};
  var S = C.strings || {};
  var ROOT = (R.root || '/').replace(/\/?$/, '/');
  var CART_ADD = (R.cartAdd || ROOT + 'cart/add') + '.js';
  var CART_CHANGE = (R.cartChange || ROOT + 'cart/change') + '.js';
  var CART_URL = R.cart || ROOT + 'cart';
  var SECTION_ID = 'levili-carrinho';
  var USE_DRAWER = C.cartType !== 'page';

  var lastFocus = null;

  /* ---------------------------------------------------------
     Utilitários
     --------------------------------------------------------- */
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function drawer() {
    return document.getElementById('CarrinhoDrawer');
  }

  function scrim() {
    return $('[data-cart-scrim]');
  }

  function toast(msg, tipo, dur, acao) {
    var fn = (window.levili && window.levili.alerta) || window.mostrarAlerta;
    if (typeof fn === 'function') fn(msg, tipo, dur, acao);
  }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function setCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
    document.querySelectorAll('[data-cart-title-count]').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
      var label = el.getAttribute('aria-label') || '';
      el.setAttribute('aria-label', label.replace(/\(\d+\)/, '(' + count + ')'));
    });
    try {
      document.dispatchEvent(new CustomEvent('carrinho:atualizado', { detail: { itemCount: count } }));
    } catch (e) {}
  }

  /* ---------------------------------------------------------
     Gaveta: abrir / fechar / foco
     --------------------------------------------------------- */
  function isOpen() {
    var d = drawer();
    return !!(d && d.classList.contains('is-open'));
  }

  function openDrawer() {
    var d = drawer();
    if (!d || !USE_DRAWER) {
      window.location.href = CART_URL;
      return;
    }
    if (!isOpen()) lastFocus = document.activeElement;
    d.removeAttribute('inert');
    d.setAttribute('aria-hidden', 'false');
    d.classList.add('is-open');
    var s = scrim();
    if (s) s.classList.add('is-open');
    document.documentElement.classList.add('is-locked');
    setTimeout(function () {
      var f = focusables(d);
      (f[0] || d).focus();
    }, 80);
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || !isOpen()) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    d.setAttribute('inert', '');
    var s = scrim();
    if (s) s.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle]');
    if (t) {
      if (!USE_DRAWER || !drawer()) return; // vai para /cart normalmente
      e.preventDefault();
      if (isOpen()) closeDrawer();
      else openDrawer();
      return;
    }
    var c = e.target.closest('[data-cart-close]');
    if (c && isOpen()) {
      /* links dentro da gaveta (ex.: "Ver os tênis") seguem normalmente */
      if (c.tagName !== 'A') e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      var d = drawer();
      var f = focusables(d);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) {
        e.preventDefault();
        f[f.length - 1].focus();
      } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
        e.preventDefault();
        f[0].focus();
      }
    }
  });

  document.addEventListener('carrinho:abrir', function () {
    openDrawer();
  });

  /* ---------------------------------------------------------
     Re-render da gaveta (Section Rendering API)
     --------------------------------------------------------- */
  function renderDrawer() {
    var url = window.location.pathname + '?sections=' + SECTION_ID;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('sections ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var html = json && json[SECTION_ID];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-content]');
        var current = $('[data-cart-content]', drawer() || document);
        if (fresh && current) {
          current.replaceWith(fresh);
          var count = parseInt(fresh.getAttribute('data-cart-item-count'), 10) || 0;
          setCounts(count);
          if (window.LeviliMotion && window.LeviliMotion.refresh) window.LeviliMotion.refresh(drawer());
        }
      });
  }

  function refreshCountOnly() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCounts(cart.item_count); })
      .catch(function () {});
  }

  /* ---------------------------------------------------------
     Adicionar ao carrinho
     --------------------------------------------------------- */
  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(action) || form.getAttribute('data-type') === 'add-to-cart-form';
  }

  function sizeError(form, show) {
    var picker = form.querySelector('[data-size-picker]');
    var holder = form.querySelector('[data-size-error]');
    if (!holder && form.id) holder = document.querySelector('[data-size-error="' + form.id + '"]');
    if (show) {
      if (holder) holder.textContent = S.chooseSize || 'Escolha o seu número para continuar.';
      if (picker) {
        picker.classList.remove('is-size-missing');
        void picker.offsetWidth;
        picker.classList.add('is-size-missing');
        var first = picker.querySelector('input[type="radio"]:not([disabled])');
        if (first) first.focus({ preventScroll: true });
        if (picker.getBoundingClientRect().top < 80 || picker.getBoundingClientRect().bottom > window.innerHeight) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    } else {
      if (holder) holder.textContent = '';
      if (picker) picker.classList.remove('is-size-missing');
    }
  }

  function needsSize(form) {
    var radios = form.querySelectorAll('[data-size-picker] input[type="radio"][name="id"]');
    if (!radios.length) return false;
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return false;
    return true;
  }

  /* Limpa o erro assim que um número é escolhido */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-size-picker] input[type="radio"]')) {
      var form = t.form || t.closest('form');
      if (form) sizeError(form, false);
    }
  });

  function handleAdd(event) {
    var form = event.target;
    if (!isAddForm(form)) return;
    if (needsSize(form)) {
      event.preventDefault();
      sizeError(form, true);
      return;
    }
    sizeError(form, false);
    if (!window.fetch || !window.FormData) return; // envio nativo
    event.preventDefault();

    var button = event.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var extraButtons = document.querySelectorAll('[data-submit-for="' + form.id + '"]');
    function busy(on) {
      [button].concat(Array.prototype.slice.call(extraButtons)).forEach(function (b) {
        if (!b) return;
        if (on) b.setAttribute('aria-busy', 'true');
        else b.removeAttribute('aria-busy');
      });
    }
    busy(true);

    var body = new FormData(form);
    if (!body.get('quantity')) body.set('quantity', '1');

    fetch(CART_ADD, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) {
        return r.json().then(function (json) {
          return { ok: r.ok, json: json };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && (res.json.description || res.json.message)) || S.cartError || 'Não foi possível adicionar.';
          toast(msg, 'negativo', 5000);
          return;
        }
        try {
          document.dispatchEvent(new CustomEvent('carrinho:adicionado', { detail: { item: res.json } }));
        } catch (e) {}
        if (!USE_DRAWER || !drawer()) {
          window.location.href = CART_URL;
          return;
        }
        return renderDrawer()
          .catch(function () { return refreshCountOnly(); })
          .then(function () {
            openDrawer();
            toast(S.addedToCart || 'Produto adicionado ao carrinho!', 'positivo', 3000);
          });
      })
      .catch(function () {
        form.submit(); // sem AJAX: envio normal
      })
      .then(function () {
        busy(false);
      });
  }

  document.addEventListener('submit', handleAdd);

  /* ---------------------------------------------------------
     Quantidade / remover dentro da gaveta
     --------------------------------------------------------- */
  function changeLine(lineEl, quantity) {
    var line = parseInt(lineEl.getAttribute('data-cart-line'), 10);
    if (!line) return;
    lineEl.classList.add('is-busy');
    fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (r) {
        return r.json().then(function (json) {
          return { ok: r.ok, json: json };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          toast((res.json && res.json.description) || S.cartError || 'Não foi possível atualizar o carrinho.', 'negativo', 5000);
        }
        return renderDrawer();
      })
      .catch(function () {
        toast(S.cartError || 'Não foi possível atualizar o carrinho.', 'negativo', 5000);
        lineEl.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;
    var q = e.target.closest('[data-cart-qty]');
    var rm = e.target.closest('[data-cart-remove]');
    var lineEl = e.target.closest('[data-cart-line]');
    if (!lineEl) return;
    if (q) {
      var input = lineEl.querySelector('[data-cart-qty-input]');
      var current = parseInt(input && input.value, 10) || 0;
      changeLine(lineEl, current + parseInt(q.getAttribute('data-cart-qty'), 10));
    } else if (rm) {
      changeLine(lineEl, 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-cart-qty-input]')) return;
    var d = drawer();
    if (!d || !d.contains(input)) return;
    var lineEl = input.closest('[data-cart-line]');
    if (lineEl) changeLine(lineEl, parseInt(input.value, 10) || 0);
  });

  /* ---------------------------------------------------------
     Página do carrinho: +/- enviam o formulário nativo
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-page-qty]');
    if (!b) return;
    var form = b.closest('form');
    var input = b.closest('[data-cart-page-line]') && b.closest('[data-cart-page-line]').querySelector('input[type="number"]');
    if (!form || !input) return;
    e.preventDefault();
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-cart-page-qty'), 10));
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  });

  /* Contador certo mesmo com página em cache */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshCountOnly);
  else refreshCountOnly();

  window.levili = window.levili || {};
  window.levili.cart = { open: openDrawer, close: closeDrawer, refresh: renderDrawer };
})();
